export const PHONE_MASK = [
  '+',
  '7',
  ' ',
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const SNILS_MASK = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
];

export const SNILS_ERROR_EMPTY: string = 'Пожалуйста, введите номер СНИЛС';
export const SNILS_ERROR_FORMAT: string = 'Номер не является СНИЛС';
export const EMAIL_FORMAT_ERROR: string = 'Укажите правильный адрес e-mail';
export const EMAIL_REQUIRED_ERROR: string = 'Обязательное поле';
export const SEND_INVITE: string = 'Отправить';
export const INVITE_PERSON: string = 'Пригласить обучающегося';



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/addchildform/consts.ts